import i18next from "i18next";
import { Button, Card, Space, Tooltip, Select, Row, Col, Input, Form, Spin } from "antd";
import { InfoCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { RoleService } from "../../../service/rolService";

const { TextArea } = Input;

const MapsAdministrationComponent = ({ dataMaps, dataRoles }) => {

    const [cargando, setCargando] = useState(false)

    const [selectedMap, setSelectedMap] = useState(undefined);
    const [inputId, setInputID] = useState("")
    const [inputNombre, setInputNombre] = useState("")
    const [inputDescripcion, setInputDescripcion] = useState("")
    const [inputPosition, setInputPosition] = useState("")
    const [selectedRol, setSelectedRol] = useState(undefined)
    const [valueTextAreaCapas, setValueTextAreaCapas] = useState("{}");

    const [datosMaps, setDataMaps] = useState(dataMaps)
    const [datosRoles, setDataRoles] = useState(dataRoles)

    const [selectMapOptions, setSelectMapOptions] = useState([]);

    let windowHeight = window.innerHeight

    /**
     * Función que controla los cambios producidos en el valor de textarea
     * 
     * @param {*} e 
     */
    const handleInputChange = (e) => {
        console.log(e)
        let reader = new FileReader();
        reader.onload = function (e) {
            setValueTextAreaCapas(e.target.result)
        }
        reader.readAsText(e.target.files[0])
    }

    const submit = () => {
        console.log(selectedMap)
        console.log(inputId)
        console.log(inputNombre)
        console.log(inputDescripcion)
        console.log(selectedRol)
    }

    /**
     * Función que retorna todos los inputs a su valor original
     */
    const reset = () => {
        setSelectedMap(undefined)
        setInputID("")
        setInputNombre("")
        setInputDescripcion("")
        setInputPosition("")
        setSelectedRol(undefined)
        setValueTextAreaCapas("{}")
    }


    const onSearch = (value) => {
        console.log('search:', value);
    };

    /**
     * Función que permite realizar el filtrado en la búsqueda en el input
     * 
     * @param {*} input 
     * @param {*} option 
     * @returns 
     */
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    /**
     * Función que convierte los datos de los mapas a un formato legible en un select
     * 
     * @returns 
     */
    const getSelectMapOptions = () => {
        let dataCopy = [...datosMaps]
        //console.log("copia", dataCopy)
        return dataCopy.map((dato) => {
            return {
                "value": dato.id,
                "label": dato.name
            }
        })
    }

    /**
     * Función que convierte los datos de los roles a un formato legible en un select
     */
    const getSelectRolOptions = () => {
        let dataCopy = [...datosRoles]
        return dataCopy.map((dato) => {
            return {
                "value": dato.idRol,
                "label": dato.name
            }
        })
    }

    /**
     * Cuando se clica el boton Crear se resetean los valores de los inputs
     */
    const onClickCrear = () => {
        reset()
    }


    /**
     * Cuando se clica el boton modificar se muestran en los inputs los valores relacionados a ese mapa
     */
    const onClickModificar = async () => {
        //console.log("mapa id", selectedMap)
        setCargando(true)
        let datosCopy = [...datosMaps]
        await RoleService.getRolMap(selectedMap)
            .then((data) => { console.log("rol", data); setSelectedRol(data.idRol) })
            .catch((error) => console.log(error))

        let datosMapa = datosCopy.find((mapa) => mapa.id == selectedMap)
        //console.log("mapa", datosMapa)
        if (datosMapa) {
            setInputID(datosMapa.id)
            setInputNombre(datosMapa.name)
            setInputDescripcion(datosMapa.description)
            setValueTextAreaCapas(datosMapa.config)
            setInputPosition(0)
            setCargando(false)
        } else {
            reset()
        }
    }

    const onClickBorrar = async () => {
        alert("TODO")
    }

    useEffect(() => {
        console.log("render", getSelectMapOptions())
        setSelectMapOptions(getSelectMapOptions())
    }, [])


    return (
        <>
            <Card>
                <Row>
                    <Col span={6}>
                        <Space direction="vertical">
                            <h2>{i18next.t('common.administration.tab_map.header.options')}</h2>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedMap == undefined ? false : true}
                                    onClick={(e) => onClickCrear()}
                                >{i18next.t('common.administration.tools.boton_crear.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_crear.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedMap == undefined ? true : false}
                                    onClick={(e) => onClickModificar()}
                                >{i18next.t('common.administration.tools.boton_modificar.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_modificar.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedMap == undefined ? true : false}
                                onClick={(e) => onClickBorrar()}>{i18next.t('common.administration.tools.boton_borrar.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_borrar.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <p>{i18next.t('common.administration.tab_map.fields.select')}</p>
                                <Select
                                    showSearch
                                    value={selectedMap}
                                    placeholder="Selecciona el mapa"
                                    allowClear
                                    optionFilterProp="children"
                                    onChange={(e) => setSelectedMap(e)}
                                    onSearch={onSearch}
                                    filterOption={filterOption}
                                    options={selectMapOptions}
                                />
                            </div>
                            {
                                cargando && <div>
                                <Space>
                                    <Spin /> <p>CARGANDO...</p>
                                </Space>
                            </div>
                            }
                        </Space>
                    </Col>
                    <Col span={18}>
                        <Row>
                            <Col span={24} style={{ "textAlign": "center" }}>
                                <h2>{i18next.t('common.administration.tab_map.header.data')}</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ "padding": "10px" }}>
                                <Form
                                    layout={"vertical"}
                                >
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.id')}>
                                        <Input placeholder="input placeholder" value={inputId} onChange={(e) => setInputID(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.name')}>
                                        <Input placeholder="input placeholder" value={inputNombre} onChange={(e) => setInputNombre(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.description')}>
                                        <Input placeholder="input placeholder" value={inputDescripcion} onChange={(e) => setInputDescripcion(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.position')}>
                                        <Input placeholder="input placeholder" value={inputPosition} onChange={(e) => setInputPosition(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.role')}>
                                        <Select
                                            showSearch
                                            value={selectedRol}
                                            placeholder="Select a person"
                                            optionFilterProp="children"
                                            onChange={(e) => setSelectedRol(e)}
                                            onSearch={onSearch}
                                            filterOption={filterOption}
                                            options={getSelectRolOptions()}
                                        />
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Col span={16} style={{ "padding": "10px" }}>
                                <Form layout={"vertical"}>
                                    <Form.Item label={i18next.t('common.administration.tab_map.fields.configuration')}>
                                        <div style={{ "display": "flex" }}>
                                            <div style={{ "marginRight": "auto" }}>
                                                <input
                                                    id='confsec'
                                                    type="file"
                                                    onChange={handleInputChange}
                                                    accept=".json"
                                                />
                                            </div>
                                            <div>
                                                <Tooltip title={i18next.t('common.administration.tools.icono_borrar.info')}>
                                                    <Button type="link" danger style={{ "border": "none" }} onClick={() => setValueTextAreaCapas("{}")}>
                                                        {<CloseOutlined style={{ "color": "red" }} />}
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <TextArea value={valueTextAreaCapas} style={{ height: windowHeight / 2, resize: 'none' }} onChange={(e) => setValueTextAreaCapas(e.target.value)} />
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} style={{ "textAlign": "center", "marginTop": "15px" }}>
                        <Space>
                            <Button size="large" onClick={() => submit()}>{i18next.t('common.administration.tools.boton_guardar.name')}</Button>
                            <Button size="large" onClick={() => reset()}>{i18next.t('common.administration.tools.boton_cancelar.name')}</Button>
                        </Space>
                    </Col>
                </Row>
            </Card>
        </>
    );

}

export default MapsAdministrationComponent;